export default "__VITE_ASSET__BKxzHIbe__"